










































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import {
  GetZlkzZhenciList,
  DangeZhiyi,
  Shenhetongguo,
  TijiaoShenhe,
} from "@/request/sjzx";
import {
  AddZhenci,
  DeleteZhenci,
  GetZhenciList,
  LeftInterviews,
  GetTemplates,
  GetContents,
  ExportZhenciData,
} from "@/request/zhuanbingshujuku";
import { GetUserInfo } from "@/request/yonghuquanxian";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
import ZhiyijiluDialog from "../../../components/zhiyijiluDialog.vue";
import ZhiyiDialog from "../../../components/zhiyiiDialog.vue";
import JianchahenjiDialog from "../../../components/jianchahenjiDialog.vue";
import ComposePatient from "./compose-patient.vue";
import Tongyong from "./details/tongyong.vue";
import Custom from "./details/custom.vue";
import Shexiang from "./details/shexiang-keyan/shexiang-keyan.vue";
import Mianxiang from "./details/mianxiang/mianxiang.vue";
import Maixiang from "./details/maixiang/maixiang.vue";
import Shou from "./details/shou/shou.vue";
import Toufa from "./details/toufa/toufa.vue";
import XitongshujuList from "./details/xitongshuju-list/xitongshuju-list.vue";
import XitongshujuDetail from "./details/xitongshuju-detail/xitongshuju-detail.vue";
@Component({
  components: {
    LeaveConfirm,
    ZhiyijiluDialog,
    ZhiyiDialog,
    JianchahenjiDialog,
    ComposePatient,
    Tongyong,
    Custom,
    Shexiang,
    Mianxiang,
    Maixiang,
    Shou,
    Toufa,
    XitongshujuList,
    XitongshujuDetail,
  },
})
export default class ZbsjkDetail extends Vue {
  private user: any = {};
  private patient: any = {
    patient_id: "",
  };

  private ifShowCompose: boolean = false;
  private tempP: any = {};
  private zhencis: any[] = [];
  private cZhenci: any = {};
  private interviews: any[] = [];
  private cTemplate: any = {};
  private message: any = {};
  private templates: any[] = [];
  private loaded: boolean = false;
  private cContent: any = {};
  private ifShowLeaveConfirm: boolean = false;
  private ifShowNavChangeConfirm: boolean = false;
  private ifShowZhenciChangeConfirm: boolean = false;
  private target: any = {};
  private tuMsg: any = {};
  private xitongList: any = {};
  private xitongDetail: any = {};
  private currentXitong: any = "LIS系统";
  private showXitongshuju: any = false;
  private xitongVisible: boolean = false;
  private showList: boolean = false;
  private isShow: boolean = true;
  // 弹窗
  private ifShowZhiyijilu: boolean = false;
  private ifShowJiancha: boolean = false;
  // 质疑
  private ifShowZhiyi: boolean = false;
  private zhiyi: any = {};
  private tempZhenci: any = {};
  private get center() {
    return JSON.parse(localStorage.getItem("center") || "{}");
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  // 导出数据
  private exportData() {
    const loading = this.$loading({ text: "加载中" });
    const params: any = {
      params: {
        project_id: this.center.project_id,
        patient_id: this.patient.patient_id,
        zhenci_id: this.cZhenci.zhenci_id,
        group_id: this.center.group_id,
        // template_id: this.cTemplate.template_id,
      },
    };
    ExportZhenciData(this, params)
      .then((res: any) => {
        console.log(9999999);
        console.log(res);
        loading.close();
        window.open(
          window.API_ROOT + "api/wajue/download?filename=" + res.file_name
        );
      })
      .catch(() => {
        loading.close();
      });
  }
  /**
   * @description 获取当前用户信息
   */
  private getCurrentUserInfo() {
    if (!this.center.project_id) {
      return;
    }
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    GetUserInfo(this, params).then((data: any) => {
      this.$set(this, "user", data);
    });
  }
  /**
   * @description 判断当前用户在当前机构下能否显示某个功能
   */
  private canThisRoleAndStateUse(tool) {
    if (!this.user["role"]) {
      return false;
    }
    let canUse = false;
    try {
      switch (tool) {
        case "添加诊次":
          if (
            this.$store.state.roleControl["数据录入"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            if (this.user.user_id === this.patient.user_id) {
              canUse = true;
            }
          }
          break;
        case "编辑":
          if (
            this.$store.state.roleControl["数据录入"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            if (
              this.cZhenci["status"] !== "失效" &&
              this.cZhenci["status"] !== "已通过"
            ) {
              if (this.user.user_id === this.patient.user_id) {
                canUse = true;
              }
            }
          }
          break;
        case "删除":
          if (
            this.$store.state.roleControl["数据录入"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            if (
              this.cZhenci["status"] !== "待审核" &&
              this.cZhenci["status"] !== "审核通过"
            ) {
              if (this.user.user_id === this.patient.user_id) {
                canUse = true;
              }
            }
          }
          break;
        case "提交":
          if (
            this.$store.state.roleControl["数据录入"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            if (
              this.cZhenci["status"] === "草稿" ||
              this.cZhenci["status"] === "已打回"
            ) {
              if (this.user.user_id === this.patient.user_id) {
                canUse = true;
              }
            }
          }
          break;
        case "查看质疑记录":
          if (
            this.cZhenci["status"] === "待审核" ||
            this.cZhenci["status"] === "已打回"
          ) {
            if (this.user.user_id === this.patient.user_id) {
              canUse = true;
            }
          }
          break;
        case "查看监查痕迹":
          if (
            this.$store.state.roleControl["监查痕迹"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
        case "质疑":
          if (
            this.$store.state.roleControl["质疑"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            if (this.cZhenci["status"] === "待审核") {
              canUse = true;
            }
          }
          break;
        case "审核通过":
          if (
            this.$store.state.roleControl["审核通过"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            if (this.cZhenci["status"] === "待审核") {
              canUse = true;
            }
          }
          break;
      }
    } catch (e) {
      console.log(e);
    }
    return canUse;
  }
  /**
   * @description 打开编辑患者信息弹窗
   */
  private openComposeDialog() {
    this.tempP = _.cloneDeep(this.patient);
    this.ifShowCompose = true;
  }
  /**
   * @description 患者信息变更
   */
  private updatePatient() {
    this.$set(
      this,
      "patient",
      JSON.parse(localStorage.getItem("patient") || "{}")
    );
  }
  /**
   * @description 获得诊次列表
   */
  private getZhenciList() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          project_id: this.center.project_id,
          group_id: this.center.group_id,
          patient_id: this.patient.patient_id,
        },
      };
      GetZhenciList(this, params)
        .then((data: any) => {
          this.zhencis = data;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 切换当前诊次
   */
  private changeZhenci(zhenci, zhenciIndex) {
    if (!this.ifCompose) {
      this.$router.replace({
        path: "/main/zbsjk/zbsjk-detail",
        query: {
          zIndex: zhenciIndex.toString(),
        },
      });
      this.cZhenci = zhenci;
      this.loaded = false;
      this.cTemplate = {};
      this.cContent = {};
      this.selectBingli();
    } else {
      this.ifShowZhenciChangeConfirm = true;
      this.target = zhenci;
    }
  }
  /**
   * @description 添加诊次
   */
  private addZhenci() {
    return new Promise((resolve, reject) => {
      const params: any = {
        project_id: this.center.project_id,
        group_id: this.center.group_id,
        patient_id: this.patient.patient_id,
      };
      AddZhenci(this, params)
        .then((data: any) => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 添加诊次按钮
   */
  private tianjiaZhenci() {
    this.addZhenci().then(() => {
      this.getZhenciList().then(() => {
        this.$router.replace({
          path: "/main/zbsjk/zbsjk-detail",
          query: {
            zIndex: (this.zhencis.length - 1).toString(),
          },
        });
        this.cZhenci = this.zhencis[this.zhencis.length - 1];
        this.cTemplate = {};
        this.cContent = {};
        this.selectBingli();
      });
    });
  }
  /**
   * @description 删除诊次
   */
  private deleteZhenci(zhenci) {
    this.$confirm("您是否确定删除？")
      .then(() => {
        const params: any = {
          data: {
            zhenci_id: zhenci["zhenci_id"],
          },
        };
        DeleteZhenci(this, params).then((data: any) => {
          this.$message.success("删除成功");
          // this.cTemplate = {};
          this.getZhenciList().then(() => {
            if (this.zhencis.length >= 1) {
              this.cZhenci = this.zhencis[0];
              this.fetchContents();
            }
          });
        });
      })
      .catch(() => {
        console.log("取消");
      });
  }
  // 刷新当前诊次状态
  private refreshCurrentZhenci() {
    this.getZhenciList().then(() => {
      if (this.$route.query.zIndex) {
        this.cZhenci = this.zhencis[Number(this.$route.query.zIndex)];
      } else {
        this.cZhenci = this.zhencis[0];
      }
    });
  }
  /**
   * @description 开始编辑
   */
  private startCompose() {
    if (this.cTemplate.template_id) {
      if (this.cTemplate["名称"] === "舌图数据") {
        this.$message.warning("舌图数据不可编辑");
        return;
      }
      this.$store.commit("updateIfCompose", true);
    } else {
      // this.$message.warning("请先选择一个量表");
    }
  }
  /**
   * @description 保存
   */
  private save() {
    if (this.cTemplate["名称"] === "面图数据") {
      (this.$refs.miantu as any).save();
    } else if (this.cTemplate["名称"] === "手图数据") {
      (this.$refs.shoutu as any).save();
    } else if (this.cTemplate["名称"] === "发图数据") {
      (this.$refs.fatu as any).save();
    } else {
      (this.$refs.custom as any).save();
    }
  }
  /**
   * @description 提交审核
   */
  private tijiaoZhenci() {
    if (this.ifCompose) {
      this.$message.success("请先对当前修改进行保存");
      return;
    }
    const params: any = {
      zhenci_id: this.cZhenci["zhenci_id"],
    };
    TijiaoShenhe(this, params).then((data: any) => {
      this.$message.success("提交审核成功");
      this.refreshCurrentZhenci();
    });
  }
  /**
   * @description 打开质疑记录
   */
  private openZhiyijilu() {
    this.ifShowZhiyijilu = true;
  }
  /**
   * @description 打开监查痕迹
   */
  private openJianchahenji() {
    this.ifShowJiancha = true;
  }
  /**
   * @description 打开质疑弹窗
   */
  private openZhiyi() {
    this.zhiyi = {};
    this.tempZhenci = _.cloneDeep(this.cZhenci);
    const params: any = {
      params: {
        zhenci_id: this.tempZhenci.zhenci_id,
      },
    };
    DangeZhiyi(this, params).then((data: any) => {
      if (!data.logs) {
        data.logs = [];
      }
      this.zhiyi = data;
      this.ifShowZhiyi = true;
    });
  }

  /**
   * @description 确认审核通过
   */
  private confirmShenhetongguo(zhenci) {
    this.$confirm("请认真查看后才点击审核通过", {
      title: "审核通过",
      confirmButtonText: "已查阅，确认审核通过",
    })
      .then(() => {
        const params: any = {
          project_id: this.center.project_id,
          patient_id: zhenci.patient_id,
          zhenci_id: zhenci.zhenci_id,
          action: "通过",
        };
        Shenhetongguo(this, params).then((data: any) => {
          this.$message.success("通过成功！");
          this.refreshCurrentZhenci();
        });
      })
      .catch(() => {
        console.log("取消");
      });
  }
  /**
   * @description 获得左侧模板
   */
  private getLeftInterviews() {
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          patient_id: this.patient.patient_id,
          project_id: this.center.project_id,
          group_id: this.center.group_id,
        },
      };
      LeftInterviews(this, params)
        .then((data: any) => {
          data.forEach((i: any) => {
            i["ifShowTemplate"] = true;
          });
          this.interviews = data;
          resolve();
        })
        .catch((e) => {
          reject();
        });
    });
  }
  /**
   * @description 选择一个左侧模板
   */
  private selectTemplate(template) {
    if (!this.ifCompose) {
      this.cTemplate = template;
      const loading = this.$loading({ text: "加载中" });
      this.fetchTemplate()
        .then(() => {
          this.fetchContents();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    } else {
      this.target = _.cloneDeep(template);
      this.ifShowNavChangeConfirm = true;
    }
  }
  /**
   * @description 快速定位到病例
   */
  private selectBingli() {
    if (!this.interviews) {
      return;
    }
    this.interviews.forEach((interview: any) => {
      if (interview["访视名称"] === "儿童体质辨识") {
        interview["templates"].forEach((template: any) => {
          if (template["名称"] === "医师版量表") {
            this.selectTemplate(template);
          }
        });
      }
    });
  }
  /**
   * @description 获取右侧详细模板信息
   */
  private fetchTemplate() {
    const type = this.cTemplate["名称"];
    return new Promise((resolve, reject) => {
      if (
        type === "舌象数据-科研版" ||
        type === "舌图数据" ||
        type === "面图数据" ||
        type === "脉图数据" ||
        type === "手图数据" ||
        type === "发图数据"
      ) {
        let arg: string = "";
        switch (type) {
          case "舌象数据-科研版":
            arg = "舌象科研";
            break;
          case "舌图数据":
            arg = "舌象科研";
            break;
          default:
            arg = type;
        }
        this.tuMsg = {
          patient_id: this.patient.patient_id,
          zhenci_id: this.cZhenci.zhenci_id,
        };
        this.loaded = true;
        reject("舌面脉数据");
      } else {
        const params: any = {
          params: {
            template_id: this.cTemplate.template_id,
          },
        };
        GetTemplates(this, params).then((data: any) => {
          this.templates = data;
          resolve();
        });
      }
    });
  }
  /**
   * @description 获取右侧数据详情
   */
  private fetchContents() {
    const params: any = {
      params: {
        patient_id: this.patient.patient_id,
        project_id: this.center.project_id,
        group_id: this.center.group_id,
        zhenci_id: this.cZhenci.zhenci_id,
        template_id: this.cTemplate.template_id,
      },
    };
    GetContents(this, params).then((data: any) => {
      this.cContent = data;
      this.loaded = true;
    });
  }

  /**
   * @description 离开保存
   */
  private leaveSave() {
    this.ifShowLeaveConfirm = false;
    if (this.cTemplate["名称"] === "面图数据") {
      (this.$refs.miantu as any).save().then(() => {
        this.$router.push("/main/zbsjk/zbsjk-list");
      });
    } else if (this.cTemplate["名称"] === "手图数据") {
      (this.$refs.shoutu as any).save().then(() => {
        this.$router.push("/main/zbsjk/zbsjk-list");
      });
    } else if (this.cTemplate["名称"] === "发图数据") {
      (this.$refs.fatu as any).save().then(() => {
        this.$router.push("/main/zbsjk/zbsjk-list");
      });
    } else {
      (this.$refs.custom as any).save().then(() => {
        this.$router.push("/main/zbsjk/zbsjk-list");
      });
    }
  }
  /**
   * @description 不保存离开
   */
  private leaveConfirmed() {
    this.$store.commit("updateIfCompose", false);
    this.$router.push("/main/zbsjk/zbsjk-list");
  }
  /**
   * @description 量表切换保存
   */
  private navChangeSave() {
    this.ifShowNavChangeConfirm = false;
    if (this.cTemplate["名称"] === "面图数据") {
      (this.$refs.miantu as any).save().then(() => {
        this.cTemplate = _.cloneDeep(this.target);
        this.target = {};
        this.$store.commit("updateIfCompose", false);
        const loading = this.$loading({ text: "加载中" });
        this.fetchTemplate()
          .then(() => {
            this.fetchContents();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loading.close();
          });
      });
    } else if (this.cTemplate["名称"] === "手图数据") {
      (this.$refs.shoutu as any).save().then(() => {
        this.cTemplate = _.cloneDeep(this.target);
        this.target = {};
        this.$store.commit("updateIfCompose", false);
        const loading = this.$loading({ text: "加载中" });
        this.fetchTemplate()
          .then(() => {
            this.fetchContents();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loading.close();
          });
      });
    } else if (this.cTemplate["名称"] === "发图数据") {
      (this.$refs.fatu as any).save().then(() => {
        this.cTemplate = _.cloneDeep(this.target);
        this.target = {};
        this.$store.commit("updateIfCompose", false);
        const loading = this.$loading({ text: "加载中" });
        this.fetchTemplate()
          .then(() => {
            this.fetchContents();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loading.close();
          });
      });
    } else {
      (this.$refs.custom as any).save().then(() => {
        this.cTemplate = _.cloneDeep(this.target);
        this.target = {};
        this.$store.commit("updateIfCompose", false);
        const loading = this.$loading({ text: "加载中" });
        this.fetchTemplate()
          .then(() => {
            this.fetchContents();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loading.close();
          });
      });
    }
  }
  /**
   * @description 量表切换不保存
   */
  private navChangeConfirmed() {
    this.ifShowNavChangeConfirm = false;
    this.cTemplate = _.cloneDeep(this.target);
    this.target = {};
    this.$store.commit("updateIfCompose", false);
    const loading = this.$loading({ text: "加载中" });
    this.fetchTemplate()
      .then(() => {
        this.fetchContents();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 诊次切换保存
   */
  private zhenciChangeSave() {
    this.ifShowZhenciChangeConfirm = false;
    if (this.cTemplate["名称"] === "面图数据") {
      (this.$refs.miantu as any).save().then(() => {
        this.cZhenci = _.cloneDeep(this.target);
        this.cTemplate = {};
        this.target = {};
        this.$store.commit("updateIfCompose", false);
      });
    } else if (this.cTemplate["名称"] === "手图数据") {
      (this.$refs.shoutu as any).save().then(() => {
        this.cZhenci = _.cloneDeep(this.target);
        this.cTemplate = {};
        this.target = {};
        this.$store.commit("updateIfCompose", false);
      });
    } else if (this.cTemplate["名称"] === "发图数据") {
      (this.$refs.fatu as any).save().then(() => {
        this.cZhenci = _.cloneDeep(this.target);
        this.cTemplate = {};
        this.target = {};
        this.$store.commit("updateIfCompose", false);
      });
    } else {
      (this.$refs.custom as any).save().then(() => {
        this.cZhenci = _.cloneDeep(this.target);
        this.cTemplate = {};
        this.target = {};
        this.$store.commit("updateIfCompose", false);
      });
    }
  }
  /**
   * @description 诊次切换不保存
   */
  private zhenciChangeConfirmed() {
    this.ifShowZhenciChangeConfirm = false;
    this.cZhenci = _.cloneDeep(this.target);
    this.cTemplate = {};
    this.target = {};
    this.$store.commit("updateIfCompose", false);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$set(
      this,
      "patient",
      JSON.parse(localStorage.getItem("patient") || "{}")
    );
    this.getCurrentUserInfo();
    this.$nextTick().then(() => {
      if (localStorage.getItem("addZhenci") === "1") {
        this.addZhenci().then(() => {
          localStorage.setItem("addZhenci", "0");
          this.getZhenciList().then(() => {
            this.cZhenci = this.zhencis[this.zhencis.length - 1];
          });
        });
      } else {
        this.refreshCurrentZhenci();
      }
      this.getLeftInterviews().then(() => {
        this.selectBingli();
      });
    });
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to, from, next) {
    if (this.ifCompose) {
      this.ifShowLeaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  /**
   * @description 导入医院业务系统数据
   */
  private importData() {
    this.xitongList = {
      total_count: 100,
      total_page: 20,
      report: [
        {
          报告名称: "总前列腺特异性分析报告",
          科室: "骨伤科",
          临床诊断: "颈椎病",
          标本种类: "血清",
          检测时间: "2018.06.13 12:00:32",
          检测人: "孟佳丽",
          医疗机构: "曙光东院",
        },
        {
          报告名称: "前列腺酸性磷酸检测报告",
          科室: "骨伤科",
          临床诊断: "颈椎病",
          标本种类: "血清",
          检测时间: "2018.05.13 10:33:32",
          检测人: "孟佳丽",
          医疗机构: "曙光西院",
        },
        {
          报告名称: "25羟维生素D检测报告",
          科室: "骨伤科",
          临床诊断: "颈椎病",
          标本种类: "血清",
          检测时间: "2018.05.12 11:30:12",
          检测人: "陈羽翔",
          医疗机构: "曙光东院",
        },
        {
          报告名称: "总前列腺特异性分析报告",
          科室: "骨伤科",
          临床诊断: "颈椎病",
          标本种类: "血清",
          检测时间: "2018.04.10 10:01:45",
          检测人: "陈羽翔",
          医疗机构: "曙光西院",
        },
        {
          报告名称: "血清胰岛素测定报告",
          科室: "骨伤科",
          临床诊断: "颈椎病",
          标本种类: "血清",
          检测时间: "2018.02.23 09:34:22",
          检测人: "孟佳丽",
          医疗机构: "曙光东院",
        },
      ],
    };
    this.xitongVisible = false;
    this.showXitongshuju = true;
    this.showList = true;
    this.isShow = true;
  }
  /**
   * @description 搜索
   */
  private searchList(e) {
    console.log("刷新列表");
    console.log(e);
  }
  /**
   * @description 返回列表页
   */
  private returnList() {
    this.showList = true;
  }
  /**
   * @description 跳转详情
   */
  private jumpDetail(e) {
    console.log("跳转详情");
    console.log(e);
    this.xitongDetail = {
      title: e["报告名称"],
      content: [
        {
          key: "姓名",
          value: "张三",
        },
        {
          key: "性别",
          value: "男",
        },
        {
          key: "年龄",
          value: "7岁",
        },
        {
          key: "科室",
          value: "骨伤科",
        },
        {
          key: "病历号",
          value: "0800883463",
        },
        {
          key: "床号",
          value: "08",
        },
        {
          key: "标本种类",
          value: "血清",
        },
        {
          key: "临床诊断",
          value: "骨关节炎",
        },
        {
          key: "采样人",
          value: "王佳怡",
        },
        {
          key: "采样时间",
          value: "2021/1/13  5:33:21",
        },
        {
          key: "检测人",
          value: "王佳怡",
        },
        {
          key: "检测时间",
          value: "2021/1/13  5:33:21",
        },
        {
          key: "审核人",
          value: "王佳怡",
        },
        {
          key: "审核时间",
          value: "2021/1/13  5:33:21",
        },
        {
          key: "报告人",
          value: "王佳怡",
        },
        {
          key: "报告时间",
          value: "2021/1/13  5:33:21",
        },
        {
          key: "报告类别",
          value: "免疫",
        },
        {
          key: "医疗机构",
          value: "曙光东院",
        },
      ],
      table: {
        headers: [
          "项目名称",
          "实际值",
          "异常标志",
          "单位",
          "参考值",
          "系统或方法学",
        ],
        data: [
          {
            项目名称: "胰岛素释放(0)(ins0)",
            实际值: "52.27",
            异常标志: "L",
            单位: "pmol/L",
            参考值: "17.80-173.00",
            系统或方法学: "化学发光法",
          },
          {
            项目名称: "C肽(0)(ins0)",
            实际值: "52.27",
            异常标志: "M",
            单位: "pmol/L",
            参考值: "17.80-173.00",
            系统或方法学: "化学发光法",
          },
        ],
      },
    };
    this.showList = false;
  }
}
